import React, { Component } from 'react';

import uuid from 'uuid/v4';

import { RadioGroupAPI } from '@philips-emr/tws-components-api';
import { Density, Direction } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { arrayOf, bool, eventListener, oneOf, shape, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, enumValues, isEnumValid, isFunction, mobile } from '@philips-emr/tws-utils';

import { Loader, NativeSelect } from '..';

import RadioButton from './radio-button';
import './radio-group.css';

@AwesomeComponent({ type: ComponentType.DATA_ENTRY, api: RadioGroupAPI })
class RadioGroup extends Component {

  static propTypes = {
    data: arrayOf(shape({
      key: string,
      label: string,
      value: string,
    })).notEnumerable(),
    enabled: bool,
    name: string,
    onBlur: eventListener,
    onChange: eventListener,
    onFocus: eventListener,
    readOnly: bool,
    uuid: string,
    value: string,
    loading: bool,
    direction: oneOf(enumValues(Direction)),
    nativeOnMobile: bool,
    density: oneOf(enumValues(Density)),
  };

  static defaultProps = {
    data: [],
    density: Density.REGULAR,
    direction: Direction.HORIZONTAL,
    enabled: true,
    nativeOnMobile: false,
    value: '',
  };

  onChange = ({ value }) => {
    const { value: oldValue, onChange } = this.props;

    isFunction(onChange) && onChange({ value, oldValue });
  };

  onChangeNative = (event) => {
    const { value: oldValue, onChange } = this.props;

    const { value } = event.value;
    isFunction(onChange) && onChange({ value, oldValue });
  };

  getClassName() {
    const { direction, density } = this.props;

    return classNames({
      'c-radio-group': true,
      [`c-radio-group--${direction}`]: isEnumValid(Direction, direction),
      [`c-radio-group--${density}`]: isEnumValid(Density, density),
    });
  }

  renderItems() {
    const { name, enabled, value, data, onBlur, onFocus, readOnly } = this.props;

    if (!data.length) {
      return <li className="c-radio-group__item">{msg('tws.radio-group.no-options')}</li>;
    }

    return (
      data.map((item, index) => (
        <li className="c-radio-group__item" key={item.key || index}>
          <RadioButton
            name={name || uuid()}
            label={item.label}
            value={item.value}
            checked={item.value === value}
            enabled={enabled}
            readOnly={readOnly}
            onChange={this.onChange}
            onFocus={onFocus}
            onBlur={onBlur} />
        </li>
      ))
    );
  }

  renderRadioGroup() {
    const { loading } = this.props;

    return (
      <div className={this.getClassName()}>
        <ul className="c-radio-group__items">
          {loading
            ? <li><Loader/></li>
            : this.renderItems()}
        </ul>
      </div>
    );
  }

  renderNative() {
    const { data } = this.props;

    return <NativeSelect data={data} onChange={this.onChangeNative} />;
  }

  render() {
    const isNative = mobile.isMobile() && this.props.nativeOnMobile;

    return isNative
      ? this.renderNative()
      : this.renderRadioGroup();
  }
}

export default RadioGroup;

